module.exports = __webpack_public_path__ + "img/i_o_my_qa.acb1066f.svg";